import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { PageSpinner } from "@/components/atoms/PageSpinner";
import type { UserRole } from "@/types/user.types";

const ADMIN_ROLES: UserRole[] = [
  "super_admin", "operations_manager", "product_manager",
  "marketing_manager", "support", "analytics_viewer",
  "content_editor", "finance_manager","admin"
];

interface Props { requiredRole?: "admin"; }

export function ProtectedRoute({ requiredRole }: Props) {
  const { isAuthenticated, user, status } = useAuthStore();
  const location = useLocation();

  // Auth hasn't bootstrapped yet — wait before making any redirect decision
  if (status === 'idle' || status === 'loading') {
    return <PageSpinner />;
  }

  if (!isAuthenticated) {
    // Pass the attempted location so useLogin can redirect back after sign-in
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole === "admin" && user && !ADMIN_ROLES.includes((user as any).role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}